export const getDefaultParameters = () => {
    const idx = new URLSearchParams(window.location.search).get("idx") ?? "";
    const co_id = new URLSearchParams(window.location.search).get("co_id") ?? "";

    return { idx, co_id };
};
